import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import './styles.css'

function Tag({ text, active }) {
  return (
    <div className={classnames({ Tag: true, active })}>
      <span>{text}</span>
    </div>
  )
}

export const TagPropTypes = {
  text: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired
}

Tag.propTypes = { active: PropTypes.bool, ...TagPropTypes }

export default Tag
